import type { Components, Theme } from "@mui/material";

export const accordionSummaryTheme: Components<Theme>["MuiAccordionSummary"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      "&.Mui-expanded": {
        borderBottom: `1px solid ${theme.palette.custom.border}`,
      },
      "& .MuiAccordionSummary-expandIconWrapper": {
        color: theme.palette.custom.icon,
      },
    }),
  },
};
